import { applicationStore } from '../../store/applicationStore';
import { partnerSkinEnums } from '../constants/partnerSkinEnums';

export function isTopC() {
  return applicationStore.partnerSkin === partnerSkinEnums.topc;
}

export function isPG() {
  return (
    applicationStore.partnerSkin === partnerSkinEnums.pg ||
    applicationStore.partnerSkin === partnerSkinEnums.bfth ||
    applicationStore.partnerSkin === partnerSkinEnums.vbet ||
    applicationStore.partnerSkin === partnerSkinEnums.limonBet ||
    applicationStore.partnerSkin === partnerSkinEnums.ebets ||
    applicationStore.partnerSkin === partnerSkinEnums.pbets ||
    applicationStore.partnerSkin === partnerSkinEnums.vbetam
  );
}
